import { Card, Divider, Grid, Typography } from '@mui/material';
import PropTypes from 'prop-types';
import React from 'react';
import FormVendorField from '../../../FormFields/FormVendorField';
import FormTitle from '../../../FormFields/FormTitle';
import { TRANSPORTATION } from '../../../formQuestionsEnum';
import { formCardStyle } from '../../../TransitionStyles';
import { FILE_TYPES } from '../../../formFileTypesEnum';

OutsourcedCompaniesForm.propTypes = {
  permissions: PropTypes.object,
};

export default function OutsourcedCompaniesForm({ permissions }) {
  return (
    TRANSPORTATION.TRANSPORTATION_OUTSOURCED_COMPANY.id in permissions && (
      <Card sx={formCardStyle}>
        <Typography sx={{ mb: 1 }} align="center" variant="body1" color="info.main">
          Outsourced Companies
        </Typography>
        <Divider sx={{ mb: 1, mt: 2, borderWidth: 1 }} />

        <Grid container spacing={1.5}>
          <Grid item xs={12}>
            <FormTitle
              fieldAttributes={{
                questionTitle: 'Transportation outsourced company',
                fieldType: 'title',
              }}
            />
            <FormVendorField
              fieldName={TRANSPORTATION.TRANSPORTATION_OUTSOURCED_COMPANY.fieldName}
              fieldAttributes={{ isEditable: permissions[TRANSPORTATION.TRANSPORTATION_OUTSOURCED_COMPANY.id] }}
              contractFileTypeId={FILE_TYPES.TRANSPORTATION_VENDOR_CONTRACT}
              invoiceFileTypeId={FILE_TYPES.TRANSPORTATION_VENDOR_INVOICE}
            />
          </Grid>
        </Grid>
      </Card>
    )
  );
}
